import useFetcher from './useFetcher';
import { useOrganization } from 'app/_providers/Organization';

type UseOrganizationCommandHook = {
  requestLicenseUpgrade: (userId: string) => void;
};

const useOrganizationCommand = (): UseOrganizationCommandHook => {
  const { organizationId } = useOrganization();
  const { fetcher } = useFetcher();

  const requestLicenseUpgrade = (userId: string): void => {
    fetcher(`${process.env.ZEUS_API_URL}/v2/organizations/${organizationId}/license/upgrade-request`, {
      method: 'POST',
      body: JSON.stringify({ requestedBy: userId }),
    });
  };

  return { requestLicenseUpgrade };
};

export const ORGANIZATION_NAME_MAX_LENGTH = 128;

export default useOrganizationCommand;
